import ReactDOM from "react-dom";
import App from "./app";
import "./styles/styles.css";
import ReactGA from 'react-ga';

ReactGA.initialize('UA-196190035-1'); // add your tracking id here.
ReactGA.pageview(window.location.pathname + window.location.search);

ReactDOM.render(<App />, document.getElementById("root"));
